/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

:host {
  display: block;
}

.web {
  background: var(--qds-theme-navigation-background);
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  overflow: hidden;
  min-height: 380px;
  max-height: calc(100vh - 220px);

  .side-nav {
    flex-direction: column;
    background-color: var(--qds-theme-navigation-background);
    overflow-y: auto;
    padding-block: 24px;
    padding-inline: 24px 0;
    width: 600.2px;
  }

  qds-divider {
    height: 1px;
    width: 100%;
  }

  .megamenu-wrapper {
    max-width: var(--qds-navigation-header-max-width, 1424px);
    width: 100%;
    display: flex;
  }

  .overflow-line {
    position: absolute;
    bottom: 0;
    height: 32px;
    width: 100%;
    background: linear-gradient(
      to bottom,
      rgb(255 255 255 / 0%),
      rgb(255 255 255 / 19%),
      rgb(255 255 255 / 100%)
    );
  }
}

.mobile {
  background-color: var(--qds-theme-panel-subsection-standard-background);
  display: flex;
  flex-direction: column;
  position: absolute;
  inset: 0;
  z-index: 2;
  overflow-y: auto;

  .menu-header {
    display: flex;
    padding: var(--qds-navigation-subsection-gap-children-unrelated);
    gap: var(--qds-navigation-subsection-gap-children-unrelated);
    flex-direction: column;
    align-items: flex-start;
    background: var(--qds-theme-panel-subsection-standard-background);
  }

  .side-nav {
    flex-direction: column;
    background-color: var(--qds-theme-navigation-background);
    padding: 0;
    width: auto;
    padding-bottom: 100px;
  }

  qds-divider {
    display: none;
  }

  .overflow-line {
    display: none;
  }
}

/* mobile and web classes */

.hide-overflow {
  overflow-y: hidden;
}

.links-gap {
  gap: var(--qds-navigation-subsection-padding-vertical);
}

.side-items {
  gap: 4px;
  display: flex;
  flex-direction: column;
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-inline-end: var(--qds-navigation-padding-horizontal);
  gap: var(--qds-navigation-subsection-padding-vertical);
  align-self: stretch;
}

.links {
  display: flex;
  padding-inline-start: var(--qds-navigation-subsection-gap-children-unrelated);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--qds-navigation-subsection-padding-vertical);
  list-style-type: none;
  align-self: stretch;
  margin: 0;
}

.content {
  width: 100%;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  width: 16px;
  height: 16px;
}

.content::-webkit-scrollbar-track {
  background: var(--qds-theme-panel-subsection-standard-background);
}

.content::-webkit-scrollbar-thumb {
  background-color: rgb(136 136 136);
  border-radius: 10px;
  border: 4px solid var(--qds-theme-panel-subsection-standard-background);
}

.content::-webkit-scrollbar-button {
  background-color: transparent;
}

.flex {
  display: flex;
}

.hide {
  display: none;
}

@media (width >= 1201px) and (width <= 1321px) {
  .side-nav {
    width: calc(580.02px + (20.18px * ((100vw - 1200px) / 121)));
  }
}
